export default __webpack_public_path__ + "static/O0092-cb8f3c608935d68c39cee3e1ef589cf0.png";